<template>
	<div class="navbar navbar-expand-lg navbar-light footer-adaptive">
		<div class="navbar-collapse collapse">
			<div class="navbar-text">&copy; 2026</div>
			<div class="version d-none d-md-block">Версия:
				<span>{{ state.constants.version }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import stateStore from "@/store";

export default {
	setup() {
		const { state } = stateStore;

		return {
			state
		}
	}
}
</script>

<style scoped>
.navbar-collapse.collapse {
	justify-content: space-between;
}

.navbar-text {
	padding: 0.5rem 0;
}

.footer-adaptive {
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	background-color: #f8f9fa;
}

/* Скрываем футер на очень маленьких экранах */
@media (max-width: 576px) {
	.footer-adaptive {
		display: none !important;
	}
}

/* Компактный футер на средних экранах */
@media (max-width: 768px) {
	.footer-adaptive .navbar-text {
		font-size: 0.8rem;
		padding: 0.3rem 0;
	}
	
	.footer-adaptive .version {
		font-size: 0.75rem;
	}
}

/* Минимальная высота футера */
.footer-adaptive {
	min-height: 35px;
}
</style>